__turbopack_context__.v({
  "loadingGradient": "InAppAgentWindow-module__Tgun1a__loadingGradient",
  "rotate-loading-gradient": "InAppAgentWindow-module__Tgun1a__rotate-loading-gradient",
});
